module.exports = __webpack_public_path__ + "img/office_dialog_icon04.95fce204.png";